// extracted by mini-css-extract-plugin
export default {"container":"pI-z","header":"qI-z","details":"rI-z","link":"sI-z"};